import { useNavigate } from "@tanstack/react-router";
import { useSetAtom } from "jotai";
import { useState } from "react";
import { Button } from "react-aria-components";
import { signInAtom } from "../auth.atoms";

export const SignInPage: React.FC = () => {
  const signIn = useSetAtom(signInAtom);
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  return (
    <main className="flex min-h-dvh items-center justify-center p-8">
      <div className="flex w-full max-w-sm flex-col gap-6 rounded-2xl border border-gray-200 bg-white p-8 shadow-sm dark:border-gray-800 dark:bg-gray-900">
        <div className="flex flex-col gap-2">
          <h1 className="text-xl font-semibold dark:text-gray-100">Sign in to PLUS</h1>
          <p className="text-sm text-gray-600 dark:text-gray-400">
            Use your Nailor Microsoft account to continue.
          </p>
        </div>
        <Button
          className="rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-sm transition data-[hovered]:bg-blue-700 data-[pressed]:bg-blue-800"
          onPress={async () => {
            setError(null);
            try {
              await signIn();
              navigate({ to: "/" });
            } catch (err) {
              setError(err instanceof Error ? err.message : String(err));
            }
          }}
        >
          Sign in with Microsoft
        </Button>
        {error && (
          <p className="text-sm text-red-600 dark:text-red-400" role="alert">
            {error}
          </p>
        )}
      </div>
    </main>
  );
};
